@import "../../../node_modules/bootstrap/dist/css/bootstrap.css";

.starch-tickets-app {
  margin: 1em;
}

.starch-tickets-app label {
  font-weight: bold;
}
.starch-tickets-app h3 {
  font-size: 1.75rem;
  border-bottom: 1px solid #cdcdcd;
  line-height: 2;
  margin-bottom: 2rem;
}

.starch-tickets-app :required:valid,
.starch-tickets-app :required:valid {
  border-left: 5px solid #42a948;
}

.starch-tickets-app :invalid:not(form) {
  border-left: 5px solid #a94442;
}

.starch-tickets-app .btn-primary:disabled {
  cursor: not-allowed;
}
